export * from "./custom-carousel.component";
